module.exports = __webpack_public_path__ + "media/img/IMG_0207-3729b6c1.jpg";